import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
import { useUiTranslator } from "@plansoft-configuration-renderer/localization";
/**
 * We currently do not indicate min or max inclusiveness
 * @param attribute
 * @returns
 */
export function NumericRangeText(props) {
    const t = useUiTranslator();
    const { valueMin, valueMax, numberFormat, unitSymbol } = props;
    if (valueMin == null && valueMax == null) {
        return _jsx(Fragment, {});
    }
    const min = valueMin != null ? numberFormat.format(valueMin) : "";
    const max = valueMax != null ? numberFormat.format(valueMax) : "";
    let rangeText = "";
    if (valueMin != null && valueMax != null) {
        rangeText = t("ConfigurationRenderer:NumericRange.between.minInclusive.maxInclusive", "{{min}} {{unitSymbol}} ‥ {{max}} {{unitSymbol}}", {
            min,
            max,
            unitSymbol,
        });
    }
    else if (valueMin != null) {
        rangeText = t("ConfigurationRenderer:NumericRange.startingFrom.minInclusive", "{{min}} {{unitSymbol}} ‥", {
            min,
            unitSymbol,
        });
    }
    else {
        rangeText = t("ConfigurationRenderer:NumericRange.upTo.maxInclusive", "‥ {{max}} {{unitSymbol}}", {
            max,
            unitSymbol,
        });
    }
    return _jsx(Fragment, { children: rangeText });
}
//# sourceMappingURL=NumericRangeText.js.map